/** @format */

import React from "react";

function HireMain() {
	return (
		<div className="row">
			<div className="col">
				<div>
					<h3 className="font-weight-bold">Hire Me</h3>
					<h5>Before we dicuss business, get to know me a bit</h5>
				</div>

				<p>
					Hi, I am Adio Mojeed, a Nigerian by Nationality and a
					frontend web developer{" "}
					<i>(on the move to become full stack)</i>. I am currently an
					undergraduate, studying Electrical and Computer Engineering
					in the prestigious Kwara state university, Malete, Ilorin. I
					actually started my career as developer early 2019 when I
					joined the Developer student Clubs (DSC), Kwara State
					University Chapter. I started as an IoT (Internet of Things)
					member where we work with python programming language but
					later have to drop out of the track to join the web
					development cohort. I am proficient in using HTML, CSS,
					Bootstrap, JavaScript, ReactJS, Sass preprocessor and
					Google&apos;s Firebase. I also involve myself in writing
					technical articles. I am an open source enthusiast and I
					also tutor students interested in learning web development.
				</p>
				<h5>Why do you need me for your project???</h5>
				<ul className="hire-list">
					<li>
						<p>
							<b>
								Do you need a befitting website for your
								business and you are in doubts who can get the
								job done?{" "}
							</b>{" "}
							<br />
							Worry no more as you have met the right dveloper who
							can deliver a stunning website for your brand with
							expertise
						</p>
					</li>
					<li>
						<p>
							<b>
								Do you have a project you are working on and you
								need collaborators?{" "}
							</b>{" "}
							<br />I am an open source enthusiast who is
							delighted to participate in numerous projects. My
							codes are elegants and I can help you improve your
							code base
						</p>
					</li>
					<li>
						<p>
							<b>
								Do you need content writers for Blogs/articles?{" "}
							</b>{" "}
							<br /> I also create worthwhile contents got blogs.
							You can check my blog page for certainty
						</p>
					</li>
				</ul>
				<button className="btn btn-success btn-block">
					<a href="mailto:adio.mojeed@gmail.com">Send me a mail</a>
				</button>
				<h5>You can also reach out to me via these platforms</h5>
				<h2 className="hero-link">
					<a href="https://github.com/Adiomojeed">
						<i className="fab fa-github"></i>
					</a>
					<a href="https://linkedin.com/in/adiomojeed">
						<i className="fab fa-linkedin"></i>
					</a>

					<a href="https://twitter.com/adio_mojeed">
						<i className="fab fa-twitter"></i>
					</a>
				</h2>
			</div>
		</div>
	);
}

export default HireMain;
